export default "__VITE_ASSET__BFRiCEmj__"